var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreimg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.563232,
    width: 106,
    height: 106,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.08 69.5632V38.7632H37.832C41.88 38.7632 44.9013 39.5112 46.896 41.0072C48.8907 42.4739 49.888 44.4099 49.888 46.8152C49.888 48.3992 49.4627 49.7926 48.612 50.9952C47.7907 52.1686 46.6173 53.1072 45.092 53.8112C43.596 54.4859 41.8067 54.8232 39.724 54.8232L40.604 52.7112C42.7747 52.7112 44.6667 53.0486 46.28 53.7232C47.8933 54.3686 49.14 55.3219 50.02 56.5832C50.9293 57.8152 51.384 59.3259 51.384 61.1152C51.384 63.7846 50.2987 65.8672 48.128 67.3632C45.9867 68.8299 42.848 69.5632 38.712 69.5632H22.08ZM30.704 63.2712H38.008C39.504 63.2712 40.6333 63.0219 41.396 62.5232C42.188 61.9952 42.584 61.2032 42.584 60.1472C42.584 59.0912 42.188 58.3139 41.396 57.8152C40.6333 57.2872 39.504 57.0232 38.008 57.0232H30.088V50.9952H36.688C38.1547 50.9952 39.2547 50.7459 39.988 50.2472C40.7213 49.7486 41.088 49.0006 41.088 48.0032C41.088 47.0059 40.7213 46.2726 39.988 45.8032C39.2547 45.3046 38.1547 45.0552 36.688 45.0552H30.704V63.2712ZM65.1416 69.5632L51.9856 38.7632H61.4016L72.4896 65.4272H66.9456L78.2976 38.7632H86.9216L73.7216 69.5632H65.1416Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreimg5);
export default __webpack_public_path__ + "static/media/coreimg5.dd52cddb96ab1bfef9d6ebdae376d988.svg";
export { ForwardRef as ReactComponent };